import { useEffect } from 'react';
import useCustomHook from '@/hooks/useCustomHook';

export default function useConceptRaceActivity({ taskProgressAPI }) {
  const { state, actions } = useCustomHook({
    defaultState: {},
    actions: {
      onAnswer: ({ gameConf, answers }) => {
        const answersCountById = {};
        for (const answer of answers) {
          if (!answersCountById[answer.conceptId]) {
            answersCountById[answer.conceptId] = {
              ...answer,
              correctCounts: 0,
              incorrectCounts: 0,
            };
          }
          if (answer.correct) {
            answersCountById[answer.conceptId].correctCounts++;
          } else {
            answersCountById[answer.conceptId].incorrectCounts++;
          }
        }

        const dedupedAnswers = Object.values(answersCountById)
          .filter(
            (answer) => answer.correctCounts == 1 || answer.incorrectCounts == 2
          )
          .map((answer) => ({
            ...answer,
            correct: answer.correctCounts == 1,
          }));

        const progress = Math.ceil(
          (dedupedAnswers.length * 100) / gameConf.animations.length
        );
        const correct = Math.ceil(
          (dedupedAnswers.filter((answer) => answer.correct).length * 100) /
            gameConf.animations.length
        );
        taskProgressAPI.PROGRESS({
          progress,
          correct,
          answers: answers.map((answer) => answer.formattedAnswer),
        });
      },
    },
  });

  useEffect(() => {}, []);

  return { state, actions };
}
